import { Card } from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { ButtonPreview } from "./ButtonPreview";

export function ColorPreview() {
  return (
    <Card className={styles.card} type="large">
      <ButtonPreview />
    </Card>
  );
}

const styles = {
  card: css({
    flex: 1,
    overflow: "hidden",
    padding: "var(--space-5)",
  }),
};
